import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { AuthRequestBnbaccess } from './auth-request-bnbaccess.model';
import { AuthRequestBnbaccessPopupService } from './auth-request-bnbaccess-popup.service';
import { AuthRequestBnbaccessService } from './auth-request-bnbaccess.service';
@Component({
    selector: 'jhi-auth-request-bnbaccess-dialog',
    templateUrl: './auth-request-bnbaccess-dialog.component.html'
})
export class AuthRequestBnbaccessDialogComponent implements OnInit {

    authRequest: AuthRequestBnbaccess;
    authorities: any[];
    isSaving: boolean;
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private authRequestService: AuthRequestBnbaccessService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['authRequest']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
    }
    clear () {
        this.activeModal.dismiss('cancel');
    }

    save () {
        this.isSaving = true;
        if (this.authRequest.id !== undefined) {
            this.authRequestService.update(this.authRequest)
                .subscribe((res: AuthRequestBnbaccess) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        } else {
            this.authRequestService.create(this.authRequest)
                .subscribe((res: AuthRequestBnbaccess) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        }
    }

    private onSaveSuccess (result: AuthRequestBnbaccess) {
        this.eventManager.broadcast({ name: 'authRequestListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError (error) {
        this.isSaving = false;
        this.onError(error);
    }

    private onError (error) {
        this.alertService.error(error.message, null, null);
    }
}

@Component({
    selector: 'jhi-auth-request-bnbaccess-popup',
    template: ''
})
export class AuthRequestBnbaccessPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private authRequestPopupService: AuthRequestBnbaccessPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if ( params['id'] ) {
                this.modalRef = this.authRequestPopupService
                    .open(AuthRequestBnbaccessDialogComponent, params['id']);
            } else {
                this.modalRef = this.authRequestPopupService
                    .open(AuthRequestBnbaccessDialogComponent);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/auth-request/auth-request-bnbaccess-dialog.component.ts